import type {
  AnyFailure,
  Person,
  PersonListResponse,
  PersonListSuccess,
} from "@b2bportal/air-booking-api";

import { trackCheckoutEvent } from "@checkout/tracking/sink";
import { PassengerErrorModalTypes } from "@checkout/types";
import { fetchUserPassengers, updateUserPassenger } from "@hopper-b2b/api";
import { ADD_PASSPORT, SAVE_TRAVELER } from "@hopper-b2b/types";
import type { ChildPassengerInformationContext } from "../context";

export const updateUserPassengerService = (
  context: ChildPassengerInformationContext,
  event: { person: Person; onUpdate?: boolean }
) =>
  new Promise((resolve, reject) => {
    const { person, onUpdate } = event;

    const { passport, driverLicense, ...restOfPayload } = person;
    const personToUpdate: Person = { ...restOfPayload };
    if (passport?.countryOfIssue?.length === 2) {
      personToUpdate.passport = passport;
    }

    updateUserPassenger({ person: personToUpdate })
      .then(() => {
        trackCheckoutEvent({ eventName: SAVE_TRAVELER, properties: {} });
        fetchUserPassengers({}).then((response: PersonListResponse) => {
          if (context.addPassport) {
            trackCheckoutEvent({
              eventName: ADD_PASSPORT,
              properties: { success: false },
            });
          }
          if ((response as AnyFailure).Response === "Failure") {
            reject({
              type: PassengerErrorModalTypes.UpdatePassenger,
              data: (response as AnyFailure).errors,
            });
          } else {
            resolve({
              id: personToUpdate.id,
              value: (response as PersonListSuccess).value,
              onUpdate,
            });
          }
        });
      })
      .catch((e) => {
        if (context.addPassport) {
          trackCheckoutEvent({
            eventName: ADD_PASSPORT,
            properties: { success: false },
          });
        }
        reject({
          type: PassengerErrorModalTypes.UpdatePassenger,
          data: e,
        });
      });
  });
